jQuery(document).ready(function($) {

  function moveProductImages() {
    console.log("Pöö");
    if ($('body.single-product').length) {
      if ($(window).width() < 768) {
        if ($('.single-product .product .summary .woocommerce-product-gallery').length == 0) {
          $('.product .woocommerce-product-gallery').insertAfter('.single-product .product .summary .price');
        }
      } else {
        if ($('.product .summary .woocommerce-product-gallery').length) {
          $('.product .summary .woocommerce-product-gallery').insertBefore('.product .summary');
        }
      }
    }
  }

  function fixedKjsNavigation() {
    if ($(window).width() < 1024 || !$('#primary-navigation-ecommerce').length) {
      return;
    }
    var top = $('#primary-navigation-ecommerce').offset().top + 30;
    $(window).scroll(function (event) {
      var y = $(this).scrollTop();
      if (y >= top) {
        $('#primary-navigation-ecommerce').addClass('fixed');
      } else {
        $('#primary-navigation-ecommerce').removeClass('fixed');
      }
      //$('.sticky-scroll-box').width($('.sticky-scroll-box').parent().width());
    });
  }

  function removeKjsFixedClass() {
    if ($(window).width() < 1024) {
      $('#primary-navigation-ecommerce').removeClass('fixed');
    }
  }

  fixedKjsNavigation();

  if ($('body.single-product').length) {
    moveProductImages();
  }

  $(window).resize(function() {
    if ($('body.single-product').length) {
      moveProductImages();
    }
    fixedKjsNavigation();
    removeKjsFixedClass();
  });
});